import React from 'react';
import { FeedbackFormElementSelect, FeedbackFormElementTypeEnum } from '../../../../../../../../types';
import { useFeedbackForm } from '../../useFeedbackFormEdit';
import { TextInputValue } from '../../../../../../../../components/text-input/TextInput';
import OptionsList from '../options-list/OptionsList';

type Props = {
  element: FeedbackFormElementSelect;
  index: number;
  showError: boolean;
  isAssessable?: boolean;
};

function FormSelect(props: Props) {
  const { element, index: parentIndex, showError, isAssessable } = props;

  const { changeElementsValue, addOption, removeOption, onChangeChecks } = useFeedbackForm();

  const isMultiChoiceAssessable = element.type === FeedbackFormElementTypeEnum.checkboxAssessable

  const handleAddOption = () => {
    addOption(parentIndex, '');
  };

  const handleRemoveOption = (index: number) => {
    removeOption(parentIndex, index);
  };

  const handleChangeOption = (index: number, value: TextInputValue) => {
    changeElementsValue(value, `${parentIndex}.options.${index}`);
  };

  return (
    <OptionsList
      options={element.options ?? []}
      showError={showError}
      onRemove={handleRemoveOption}
      onChange={handleChangeOption}
      onAdd={handleAddOption}
      parentIndex={parentIndex}
      isAssessable={isAssessable}
      checkedList={element.assessments ?? []}
      onChangeChecks={onChangeChecks}
      isMultiChoiceAssessable={isMultiChoiceAssessable}
    />
  );
}

export default FormSelect;
